export default __webpack_public_path__ + "static/media/misc-books3-2048w.805db2b1.avif";